import { render, staticRenderFns } from "./AppIconButton.vue?vue&type=template&id=b880b106&scoped=true"
import script from "./AppIconButton.vue?vue&type=script&lang=js"
export * from "./AppIconButton.vue?vue&type=script&lang=js"
import style0 from "./AppIconButton.vue?vue&type=style&index=0&id=b880b106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b880b106",
  null
  
)

export default component.exports